import { createSlice } from "@reduxjs/toolkit";

const getInitialCart = () => {
  const stored = localStorage.getItem("cartItems");
  return stored ? JSON.parse(stored) : [];
};

const cartSlice = createSlice({
  name: "cart", // 这个是slice的名字，用来标识这个slice
  initialState: {
    cartItems: getInitialCart(), // 初始状态，可以通过一个函数获取，通常从localStorage或其他地方读取初始数据
  },
  reducers: {
    // reducers包含了处理状态更新的函数
    addItem: (state, action) => {
      const existingItem = state.cartItems.find(
        (item) =>
          item.id === action.payload.id &&
          item.checked === action.payload.checked
      );
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.cartItems.push({ ...action.payload, quantity: 1 });
      }
    },
    removeItem: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.id !== action.payload //action.payload 是 action 对象中存储数据的地方，通常用于传递更新状态所需的具体信息
      );
    },
    clearCart: (state) => {
      state.cartItems = [];
    },
    replaceCart: (state, action) => {
      state.cartItems = action.payload;
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.cartItems.find((item) => item.id === id);
      if (item) {
        const newQuantity = item.quantity + quantity;
        if (newQuantity > 0) {
          item.quantity = newQuantity;
        } else {
          state.cartItems = state.cartItems.filter((item) => item.id !== id);
        }
      }
    },
  },
});

export const { addItem, removeItem, clearCart, replaceCart, updateQuantity } =
  cartSlice.actions;
export default cartSlice.reducer;
